//#region
import { useState, useEffect } from 'react';
// material
import { Container, Stack, TextField, Typography, DialogActions, Button, Alert, Pagination } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
// components
import Page from "../components/Page";
import Loader from "./Loader";
import Popup from '../components/Popup';
import Controls from '../components/controls/Controls';
import { addDataSource, deleteDataSource, updateActivationStatus, updateDataSource,getDataSource } from '../config/services/dataSource';
import { addVersion } from '../config/services/config';

import DataSourceTable from '../components/_dataSource/tables/DataSourceTable';
import { DataSourcePopup } from '../components/_dataSource/tables';
//#endregion

export default function DataSource() {
    const [openPopup, setOpenPopup] = useState(false);
    const [dataSourceList, setDataSourceList] = useState([]);
    const [recordForEdit, setRecordForEdit] = useState(null)
    const [dataSourceCount, setDataSourceCount] = useState(0)
    const [search, setSearchValue] = useState('')
    const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
    const [loader, setLoading] = useState(false)
    const [pageNo, setPagination] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [deleteObj, setDeleteObj] = useState({})
    const [deletePopup, setDeletePopup] = useState(false)


    const addOrEdit = (request, resetForm) => {
        const { dbName,dbHost,dbType,dbPassword,dbUser, dbSSL, dbPort, _id, projectId,bqKeyFileInfo } = request


        if(!dbType) {
            toast.error('DB Type is required');
            return;
        }

      if(dbType !== 'bigQuery') {
        if(!dbHost) {
            toast.error('DB Host is required');
            return;
        }
        if(!dbName) {
            toast.error('DB Name is required');
            return;
        }
        if(!dbUser) {
            toast.error('DB User is required');
            return;
        }
        if(!dbPassword) {
            toast.error('DB Password is required');
            return;
        }
      }
      else {
        if(!projectId) {
            toast.error('Project ID is required');
            return;
        }
        if(!bqKeyFileInfo) {
            toast.error('Key File is required');
            return;
        }
      }

        if (request?._id) {
            updateDataSource({dbName,dbHost,dbType,dbPassword,dbUser,dbSSL, dbPort,dataSourceId: _id,...(projectId && {projectId}),...(bqKeyFileInfo && {bqKeyFileInfo})})
                .then((res) => {
                    if (res?.data?.error?.errorMessage) {
                        toast.error(res?.data?.error?.errorMessage);
                    } else {
                        if(res?.status === false) {
                             toast.error(res?.message)
                        }
                        else {
                            resetForm()
                            setOpenPopup(false);
                            setRecordForEdit(null)
                            fetchDataSourceList();
                            toast.success(res?.message)
                        }
                     } 
                });
        } else {
            addDataSource({dbName,dbHost,dbType,dbPassword,dbUser, dbSSL, dbPort,...(projectId && {projectId}), ...(bqKeyFileInfo && {bqKeyFileInfo})})
                .then((res) => {
                    if (res?.data?.error?.errorMessage) {
                        toast.error(res?.data?.error?.errorMessage);
                    } else {
                        if(res?.status === false) {
                             toast.error(res?.message)
                        }
                        else {
                            resetForm()
                            setOpenPopup(false);
                            setRecordForEdit(null)
                            fetchDataSourceList();
                            toast.success(res?.message)
                        }
                    }
                });;
        }
    }


    let totalPages = Number((dataSourceCount / itemsPerPage).toFixed(0))
    if ((totalPages * itemsPerPage) < dataSourceCount)
        totalPages = totalPages + 1;

    const fetchDataSourceList = () => {
        let params = { pageNo: (pageNo - 1), count: itemsPerPage, search, ...sortObj }
        setLoading(true)
        getDataSource(params).then((res) => {
            setDataSourceList(res?.result);
            setDataSourceCount(res?.totalCount)
            setLoading(false)
        });
    }

    const openInPopup = roleEdit => {
        setRecordForEdit(roleEdit)
        setOpenPopup(true)
    }

    const deleteDataSourceF = params => {
        setDeleteObj(params)
        setDeletePopup(true)
    }

    const submitDeleteDataSource = () => {
        let { _id } = deleteObj
        deleteDataSource({ dataSourceId:_id })
            .then(res => {
                handleCancelDelete()
                fetchDataSourceList()
                toast.success(res?.message)
            })
    }

    const handlePagination = (e, pageNumber) => {
        setPagination(pageNumber)
    }

    const handleSearch = (e) => {
        let { value } = e.target
        setPagination(1)
        setSearchValue(value, () => setPagination(1))
}

    const handleDataSourceActivation = (dataSource,index) => {
        const dataS = [...dataSourceList]
        for(let list=0; list < dataS.length; list++) {
           if(index-1===list) {
               dataS[list].isActive = !dataS[list].isActive
           }
           else {
               dataS[list].isActive = false;
           }
        }
        setDataSourceList(dataS)
       
       updateDataSource({dataSourceId: dataSource?._id,isActive: dataSource?.isActive}).then( result => {
           if(result?.result) {
               updateActivationStatus({dataSourceId: dataSource?._id}).then( async resp => {
                   fetchDataSourceList();
                   await addVersion(new Date().getTime().toString())
                   localStorage.removeItem('selectedDataSetObj')
                   toast.success('DataSource Updated Successfully')
               })
               
           }
       })
    }

    const handleCancelDelete = () => {
        setDeletePopup(false)
        setDeleteObj({})
    }

    useEffect(() => fetchDataSourceList(), [search, sortObj, pageNo, itemsPerPage]);

    return (
        <>
            <Page title="Extramarks | DataSource ">
                <Container className='table_max_width'>
                    <Stack direction="row" alignContent="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4">
                            Data Source
                        </Typography>

                        <Stack direction="row" spacing={1} flexShrink={0} sx={{ my: 1 }}>
                            <TextField
                                type="search"
                                label="Search by dataSource"
                                onChange={handleSearch}
                            />
                            <Controls.Button
                                text="New DataSource"
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={() => { setOpenPopup(true); setRecordForEdit(null); }}
                            />


                        </Stack>
                    </Stack>
                    {loader && <Loader />}
                    {dataSourceList?.length ? <DataSourceTable list={dataSourceList} openInPopup={openInPopup} deleteDataSource={deleteDataSourceF} pageNo={pageNo} itemsPerPage={itemsPerPage} handleDataSourceActivation={handleDataSourceActivation} /> :
                        <Alert severity="error">No Content Available!</Alert>}
                </Container>

                <div className='center cm_pagination'>
                    <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
                </div>
            </Page>


            <Popup
                title={recordForEdit ? "Edit DataSource" : "Add DataSource"}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
            >
                <DataSourcePopup
                    recordForEdit={recordForEdit}
                    addOrEdit={addOrEdit}
                    setOpenPopup={setOpenPopup}
                />
            </Popup>

            <Popup title={`Are you sure to delete this Role "${deleteObj?.dbName}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                    <Button onClick={submitDeleteDataSource} color="error" autoFocus>Delete</Button>
                </DialogActions>
            </Popup>
        </>
    )
}
